
(() => {
  const timers = new Map();
  const init = (root = document) => {
    root.querySelectorAll('[data-bm-hero]').forEach(hero => {
      if (hero.dataset.bmReady) return;
      hero.dataset.bmReady = 'true';
      const slides = [...hero.querySelectorAll('.bm-hero__slide')];
      const dots = hero.querySelector('.bm-hero__dots');
      if (!slides.length || !dots) return;
      let current = 0;
      const show = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
        [...dots.children].forEach((dot, i) => {
          dot.classList.toggle('is-active', i === current);
          dot.setAttribute('aria-pressed', String(i === current));
        });
      };
      const stop = () => { clearInterval(timers.get(hero)); timers.delete(hero); };
      const start = () => {
        stop();
        if (hero.dataset.autoplay !== 'true' || window.Shopify?.designMode || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timers.set(hero, setInterval(() => show(current + 1), Number(hero.dataset.interval) || 7000));
      };
      slides.forEach((slide,i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Show project ' + (i + 1));
        dot.addEventListener('click', () => { show(i); start(); });
        dots.append(dot);
      });
      hero.querySelector('.bm-hero__arrow--prev')?.addEventListener('click', () => { show(current - 1); start(); });
      hero.querySelector('.bm-hero__arrow--next')?.addEventListener('click', () => { show(current + 1); start(); });
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', start);
      hero.addEventListener('shopify:block:select', event => {
        const index = slides.findIndex(slide => slide.dataset.bmBlock === event.detail.blockId);
        if (index >= 0) { stop(); show(index); }
      });
      show(0); start();
    });
    root.querySelectorAll('.bm-showroom').forEach(showroom => {
      if (showroom.dataset.bmReady) return;
      showroom.dataset.bmReady = 'true';
      const frame = showroom.querySelector('iframe');
      const buttons = [...showroom.querySelectorAll('.bm-location-select')];
      buttons.forEach(button => button.addEventListener('click', () => {
        if (!frame || !button.dataset.mapSrc) return;
        frame.src = button.dataset.mapSrc;
        frame.title = button.dataset.mapTitle;
        buttons.forEach(item => {
          const active = item === button;
          item.setAttribute('aria-pressed', String(active));
          item.closest('.bm-location-card').classList.toggle('is-active', active);
          item.querySelector('small').textContent = active ? 'Viewing on map' : 'Show on map';
        });
      }));
    });
    root.querySelectorAll('.bm-mega-menu').forEach(menu => {
      if (menu.dataset.bmReady) return;
      menu.dataset.bmReady = 'true';
      const feature = menu.querySelector('.bm-mega-menu__feature');
      const image = feature?.querySelector('img');
      const text = feature?.querySelector('span');
      const cta = feature?.querySelector('small');
      if (!feature || !image || !text || !cta) return;
      const title = [...text.childNodes].find(node => node.nodeType === 3);
      const description = document.createElement('em');
      text.insertBefore(description,cta);
      const show = link => {
        if (!link.dataset.previewTitle) return;
        feature.href = link.href;
        title.nodeValue = link.dataset.previewTitle;
        description.textContent = link.dataset.previewText || '';
        if (link.dataset.previewImage) {
          image.removeAttribute('srcset');
          image.src = link.dataset.previewImage;
          image.alt = link.dataset.previewTitle;
        }
        menu.querySelectorAll('[data-preview-title]').forEach(item => item.classList.toggle('is-previewed', item === link));
      };
      menu.querySelectorAll('[data-preview-title]').forEach(link => {
        link.addEventListener('mouseenter', () => show(link));
        link.addEventListener('focus', () => show(link));
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-bm-hero]').forEach(hero => {
      clearInterval(timers.get(hero)); timers.delete(hero);
    });
  });
})();
